/**
 * Bridge(WebView ↔ Native) 통신 과정에서 발생하는 에러
 * Native 또는 Bridge 응답 코드 기반의 예외 처리용
 */
export class BridgeError extends Error {
  public resultCd: string;
  constructor(resultCd: string, resultMsg: string) {
    super(resultMsg);
    this.name = "BridgeError";
    this.resultCd = resultCd;
  }
}
/**
 * HTTP 요청은 성공했지만
 * 비즈니스 로직 처리 중 실패한 경우 발생하는 에러
 *
 * 예:
 * - 포인트 부족
 * - 존재하지 않는 상품
 * - 이미 처리된 요청
 */
export class BusinessError extends Error {
  public resultCd: string;
  public data?: unknown;
  constructor(resultCd: string, message: string, data?: unknown) {
    super(message);
    this.name = "BusinessError";
    this.resultCd = resultCd;
    this.data = data;
  }
}
